// 生产环境导入组件
// module.exports = file => () => import('@/views' + file)
// 开发环境导入组件
module.exports = file => require('@/views' + file).default // vue-loader at least v13.0.0+



// WEBPACK FOOTER //
// ./src/utils/_import_production.js